// extracted by mini-css-extract-plugin
module.exports = {"header":"dh-dh-klima-spesial-english-header--a5dcc3f48075c6584c5f0161a3cf888e"};